import React, { useEffect, useState } from 'react'
import { FaTrashCan } from 'react-icons/fa6'
import { MdOutlineKeyboardAlt, MdOutlineBorderColor } from "react-icons/md"
import CircularProgress from '@mui/material/CircularProgress';
import nodata from '../assets/images/nodata.webp'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { deleteMaintenance, fetchMaintenances } from '../reducers/MaintenanceSlice';
import { deleteHistory, fetchHistories, setCurrentPage } from '../reducers/HistorySlice';
const History = () => {
  const dispatch = useDispatch()
  const [openDialog, setOpenDialog] = useState(false)
  const [historyToDelete, setHistoryToDelete] = useState(null)
  const [searchQuery, setSearchQuery] = useState("");
  const { histories, totalPages, totalHistories, currentPage, status } = useSelector(state => state.histories)

  useEffect(() => {
    dispatch(fetchHistories({ page: currentPage, searchQuery }));
  }, [dispatch, currentPage, searchQuery]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      dispatch(setCurrentPage(newPage))
    }
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setHistoryToDelete(null)
  }

  const handleDeleteClick = (maintenanceId) => {
    setHistoryToDelete(maintenanceId)
    setOpenDialog(true)
  }

  const handleConfirmDelete = async () => {
    if (historyToDelete) {
      try {
        await dispatch(deleteHistory(historyToDelete)).unwrap();
        await dispatch(fetchHistories({ page: currentPage, searchQuery: '' }));
        toast.success('History deleted successfully!');
      } catch (error) {
        toast.error('Failed to delete the History. Please try again.');
      } finally {
        setOpenDialog(false);
        setHistoryToDelete(null);
      }
    }
  };
  return (
    <>
      <div className='student-container'>
        <div className="table-header d-flex justify-content-between align-items-center p-2">
          <div className="total-count">
            <h6 className='mb-0'>Total Histories ({totalHistories})</h6>
          </div>
          <div className="search-box">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className="add-btn">
            <Link to={"/histories/add-history"}><button className="btn btn-primary text-white p-1">Add New</button></Link>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sr #</th>
                <th scope="col">Total Students</th>
                <th scope="col">Paid Amount</th>
                <th scope="col">Received Amount</th>
                <th scope="col">Month</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {status === 'loading' ? (
                <tr>
                  <td colSpan="6" className="loading-container">
                    <CircularProgress />
                  </td>
                </tr>
              ) : histories?.length > 0 ? (
                histories.map((history, index) => (
                  <tr key={history._id}>
                    <td scope="row">{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{history.students}</td>
                    <td>{history.paidAmount?.toLocaleString()}</td>
                    <td>{history.receivedAmount?.toLocaleString()}</td>
                    <td>{history.month}</td>
                    <td className="action-flex">
                      <Link to={`/histories/view-history/${history._id}`}>
                        <MdOutlineKeyboardAlt className="keyboard" />
                      </Link>
                      <Link to={`/histories/edit-history/${history._id}`}>
                        <MdOutlineBorderColor className="edit" />
                      </Link>
                      <FaTrashCan className="delete" onClick={() => handleDeleteClick(history._id)} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="no-data">
                    <img src={nodata} alt="No Data" />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="pagination-1 d-flex justify-content-center gap-3 align-items-center">
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1 || status === 'loading'}
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </button>
        <div className="page-info">
          Page {currentPage} of {totalPages}
        </div>
        <button
          className="pagination-btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || status === 'loading'}
        >
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this History Data?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Cancel</Button>
          <Button onClick={handleConfirmDelete} color="secondary">Delete</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default History
